module.exports = __webpack_public_path__ + "media/images/athletes/3574-45c62b59fe503811536781c8b4e7179c.png";